{
  "name": "flink",
  "version": "1.0.4",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "jest",
    "test:ci": "jest --ci --coverage",
    "test:watch": "jest --watch",
    "typecheck": "tsc -p tsconfig.app.json --noEmit && tsc -p tsconfig.spec.json --noEmit",
    "release:patch": "npm version patch",
    "release:minor": "npm version minor",
    "release:major": "npm version major"
  },
  "engines": {
    "node": ">=22.12.0",
    "npm": ">=10.9.0"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.11",
    "@angular/cdk": "21.2.9",
    "@angular/common": "21.2.11",
    "@angular/compiler": "21.2.11",
    "@angular/core": "21.2.11",
    "@angular/forms": "21.2.11",
    "@angular/platform-browser": "21.2.11",
    "@angular/platform-browser-dynamic": "21.2.11",
    "@angular/router": "21.2.11",
    "@po-ui/ng-components": "21.21.0",
    "@po-ui/ng-templates": "21.21.0",
    "@po-ui/style": "21.21.0",
    "@popperjs/core": "^2.11.8",
    "@types/intro.js": "^5.1.1",
    "bootstrap": "^5.2.3",
    "intro.js": "^7.0.1",
    "jwt-decode": "^4.0.0",
    "rxjs": "~7.8.1",
    "tslib": "^2.6.2",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.9",
    "@angular/cli": "21.2.9",
    "@angular/compiler-cli": "21.2.11",
    "@types/jest": "^30.0.0",
    "@types/node": "^22.10.0",
    "jest": "^30.0.0",
    "jest-environment-jsdom": "^30.4.1",
    "jest-preset-angular": "^16.2.0",
    "jsdom": "^26.0.0",
    "typescript": "^5.8.2"
  }
}
